// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBar-cls1_4G6","cls2":"SearchBar-cls2_Uq5 SearchBar-cls1_4G6"};